module.exports = __webpack_public_path__ + "img/activation_repo.03da969f.svg";